import React,{ useEffect, useState } from 'react';
import {Page } from 'react-weui';
import { getCategoryList } from '@/services/home';
import styles from './styles.scss';
import { history } from 'umi';


export default (props) => {

  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    getCategoryList().then(res => {
      if (res && res.code == 200) {
        setCategoryList(res.data);
      }

    });
  },[]);



  return (
    <Page style={{'background-color':'rgb(245, 246, 247)'}} transition={true} infiniteLoader={false} ptr={false}>

      <div className={styles.grid_box}>
        {categoryList.map(item => (
          <div className={styles.grid_item} key={item.id}>

            <div className={styles.grid_btn} onClick={() => {
              history.push({pathname:'/home/courseList',state:{title:item.name ,categoryId:item.id}})
            }}>
              <img alt='' src={item.image}/>
              <label>{item.name}</label>
            </div>

          </div>
        ))}
      </div>
    </Page>
  )
}
